<template>
  <div class="base-term">
    <div class="hd ly-card">
      <h3><i class="el-icon-warning"></i> 如需修改学员出生日期范围计算方式请联系工程师</h3>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :tableConfig="tableConfig"
      :searchFormData="searchFormData"
      :paginConfig="paginConfig"
      ref="lyTable"
      class="ly-card"
    >
      <template v-slot:activate_status="row">
        <el-button
          @click="statusRow(row, row.activate_status)"
          type="text"
          :class="row.activate_status && 'el-button--danger'"
          size="mini"
          >{{ row.activate_status ? '禁用' : '启用' }}</el-button
        >
      </template>
      <template v-slot:time="row">
        {{`${row.start_time}-${row.end_time}`}}
      </template>
      <template v-slot:action="row">
        <template>
          <el-button @click="editRow(row)" type="primary" size="mini">编辑</el-button>
          <el-button @click="delRow(row)" type="danger" size="mini">删除</el-button>
        </template>
      </template>
    </ly-table>
    <el-dialog
      :title="`${defaultFormItem.id ? '修改' : '新增'}学期`"
      :visible.sync="dialogVisible"
      width="600px"
      @opened="openEvent"
    >
      <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyForm"></ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addHoliday">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import { termTable } from '@/utils/tableHeader';
import { termFormItem } from '@/utils/formConfig';
import { base } from '@/api';

export default {
  name: 'baseTerm',
  components: {
    LyTable,
    LyForm,
    ElDialog: Dialog
  },
  data() {
    return {
      dialogVisible: false,
      formKeys: {},
      defaultFormItem: {},
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      searchFormData: {
        year: ''
      },
      tableHeader: termTable,
      getTableData: () => ({}),
      tableConfig: {
        data: [{
          term: '春',
          code: '01',
          type: '（本学年-最大年龄）1月1日-1月1日（本学年-最小年龄）'
        }, {
          term: '夏',
          code: '02',
          type: '（本学年-最大年龄）7月1日-7月1日（本学年-最小年龄）'
        }, {
          term: '秋',
          code: '03',
          type: '（本学年-最大年龄）7月1日-7月1日（本学年-最小年龄）'
        }, {
          term: '上学期',
          code: '04',
          type: '（本学年-最大年龄）9月1日-8月31日（本学年-最小年龄）'
        }, {
          term: '下学期',
          code: '05',
          type: '不招生'
        }],
        total: 4
      },
      paginConfig: {
        isHide: true
      },
      options: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
      const { year, term } = await this.$store.dispatch('schoolYear/getTermAndYearList');
      this.options = Object.freeze(year);
      termFormItem.year.options.select = year;
      termFormItem.term.options.select = term;
      this.formKeys = termFormItem;
    },
    openEvent() {
      this.$refs.lyForm.$refs.lyForm.clearValidate();
    },
    search() {
      this.$refs.lyTable.setData();
    },
    openDigFrom(isAdd) {
      this.dialogVisible = true;
      if (isAdd) {
        this.defaultFormItem = {};
      }
    },
    async addHoliday() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (this.defaultFormItem.id) {
          // 修改
          res = await base.controlTermMange({
            methold: 'put',
            id: this.defaultFormItem.id,
            params: {
              ...data,
              end_time: data.date[1],
              start_time: data.date[0]
            }
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          // 新增
          res = await base.addTermManage({
            params: {
              ...data,
              end_time: data.date[1],
              start_time: data.date[0]
            },
            methold: 'post'
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '新增成功');
        }
        if (res) {
          this.$refs.lyTable.setData();
          this.dialogVisible = false;
        }
      }
    },
    delRow(row) {
      this.$confirm('确认删除？')
        .then(() => {
          base
            .controlTermMange({
              methold: 'delete',
              id: row.id
            })
            .then(res => {
              this.search();
              this.$store.dispatch('msg/showMsg', res.msg || '删除成功');
            });
        })
        .catch(() => {});
    },
    editRow(row) {
      this.defaultFormItem = { ...row, date: [row.start_time, row.end_time] };
      this.openDigFrom();
    }
  }
};
</script>

<style lang="less">
.base-term {
  .hd {
    overflow: hidden;
    .el-input {
      width: 200px;
      margin-right: 20px;
    }
  }
  .ly-form .el-input {
    width: 350px;
  }
  .el-icon-warning {
    color: @danger;
  }
}
</style>
